import { render } from "./vhpFooter.vue?vue&type=template&id=eca0b238"
import script from "./vhpFooter.vue?vue&type=script&lang=js"
export * from "./vhpFooter.vue?vue&type=script&lang=js"

import "./vhpFooter.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__